import { XLSX_MIME_TYPE } from "@repo/utils";
import type { GetAllInput } from "@types_def/common/filter.types";
import type { Delivery } from "@types_def/models/delivery.types";
import { navigateToBuffer } from "@/utils/download";

import { sendRequest } from "../../clients/axios";

export function downloadDeliveries(filters: GetAllInput<Delivery, "id">) {
  return sendRequest<GetAllInput<Delivery, "id">, { data: Iterable<number> }>(
    "post",
    "delivery/export-deliveries-excel-admins",
    filters
  ).then((res) => {
    if (res.status === 201) {
      navigateToBuffer(new Uint8Array(res.data.data), XLSX_MIME_TYPE);
    }
  });
}
